import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import CopyToClipboard from "react-copy-to-clipboard";

import SideTray from "../../atoms/SideTray";
import breakpoints from "../../../styles/breakpoints";
import { colors, header } from "../../../styles/variables";
import StyledSideTrayHeader from "../../atoms/StyledSideTrayHeader";
import Button from "../../atoms/Button";

const StyledSideTray = styled((props) => <SideTray {...props} />).attrs(() => ({
  displayName: "StyledSideTray",
}))`
  ${breakpoints.smUp} {
    padding-top: 40px;
    ${(props) =>
      props.isInBoxAndCartTray &&
      css`
        top: 0;
      `}
  }
  ${breakpoints.mdDown} {
    top: 0;
  }
  ${breakpoints.smDown} {
    ${(props) =>
      props.isInBoxAndCartTray &&
      css`
        top: ${header.mobileHeight};
      `}
  }
  padding: 0px 0px 120px 0px;
`;

const ShareLinkTrayContainer = styled.div`
  padding: 0px 30px;
  ${breakpoints.smDown} {
    padding: 10px 20px;
  }
`;

const Wrapper = styled.div`
  height: 60px;
  margin: 10px 0;
  padding: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border: ${colors.black} solid 2px;
  align-items: center;
`;

const DisplayLinkInput = styled.input`
  flex: 1 1 auto;
  height: 40px;
  font-size: 0.9em;
  padding: 5px;
  border: none;
  outline: none;
  background-color: transparent;
  ${breakpoints.xsDown} {
    width: 0;
  }
`;

const headerTextStyle = css`
  text-align: left;
  padding: 0px 30px;
  ${breakpoints.smDown} {
    text-align: center;
    padding: 0px 20px;
  }
`;

const ShareLinkTray = ({
  isInBoxAndCartTray = false,
  onShareLinkTrayClose,
  urlLink,
  copyLinkClickTrack = () => {},
}) => {
  const [isUrlCopied, setIsUrlCopied] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  // Clears out timer when component un-mounts, and prevents memory leak.
  useEffect(
    () => () => {
      clearTimeout(timeoutId);
    },
    [timeoutId]
  );

  /**
   * Handles the case when user copies the link,
   * and sets a timer of 10 seconds until the button is clickable again.
   * */
  const handleCopyUrl = () => {
    copyLinkClickTrack();
    setIsUrlCopied(true);
    const timeOutHandler = () => setIsUrlCopied(false);
    const timeOutID = setTimeout(timeOutHandler, 10000);
    setTimeoutId(timeOutID);
  };

  return (
    <StyledSideTray
      shouldAnimate
      isInBoxAndCartTray={isInBoxAndCartTray}
      isOpened
      onClickBackdrop={() => onShareLinkTrayClose()}
      color={colors.white}
    >
      <StyledSideTrayHeader
        title="Share"
        handleChange={() => onShareLinkTrayClose()}
        textStyle={headerTextStyle}
      />
      <ShareLinkTrayContainer>
        <Wrapper>
          <DisplayLinkInput value={urlLink || ""} onChange={() => {}} />
          <CopyToClipboard text={urlLink} onCopy={() => handleCopyUrl()} rightGutter>
            <Button ghost disabled={urlLink === "" || isUrlCopied}>
              <span>{isUrlCopied ? " Copied" : "Copy Link"}</span>
            </Button>
          </CopyToClipboard>
        </Wrapper>
      </ShareLinkTrayContainer>
    </StyledSideTray>
  );
};

ShareLinkTray.propTypes = {
  isInBoxAndCartTray: PropTypes.bool,
  onShareLinkTrayClose: PropTypes.func.isRequired,
  urlLink: PropTypes.string.isRequired,
  copyLinkClickTrack: PropTypes.func,
};

export default ShareLinkTray;
